import { DataCollectorInstance, TransactionCollector } from '@scfe-common/core';
import { handleResponseData } from '../../utils';
import { ActionType, RequestState } from '@scfe-common/chain-tracker';
import { CustomActionType } from '@/utils/chain-tracker/plugins/types';

export default [
  {
    name: 'SLASaleInboundArriving',
    status: {
      errorCount: 0,
    },
    scanTime: 'custom_InboundArriving_scan_time',
    scanErrorCount: 'custom_InboundArriving_scan_time_error_count',
    collector: {} as TransactionCollector,
    getPointList: function () {
      return [
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#purchase-arriving-input-orderId',
          },
          handler: () => {
            this.collector = DataCollectorInstance.createTransactionCollector();
            this.collector.startTrack({
              name: this.scanTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/purchaseinbound\/puarrival\/create_arrival(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);
            if (response?.retcode !== 0) {
              const [result] = this.collector.endTrackByName({
                name: this.scanTime,
                isSuccess: true,
              });

              sendDataFn({
                pointId: result.name,
                customData: { ...result, type: 'experienceTime' },
              });
              sendDataFn({
                pointId: this.scanErrorCount,
                customData: {
                  errorCount_n: 1,
                  type: 'experienceCount',
                },
              });
              DataCollectorInstance.removeTransactionCollector({
                traceId: this.collector.traceId,
              });
            }
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/purchaseinbound\/puarrival\/check_can_complete(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
            DataCollectorInstance.removeTransactionCollector({
              traceId: this.collector.traceId,
            });
          },
        },
      ];
    },
  },
];
